import { PaymentMethod } from './PaymentMethod'
import { withPaymentMethod } from './withPaymentMethod'

const ConnectedPaymentMethod = withPaymentMethod(PaymentMethod)

export { ConnectedPaymentMethod as PaymentMethod }
